import { io } from 'socket.io-client';
import store from '../store';

// Получаем URL API из переменных окружения или используем значение по умолчанию
const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';
console.log('Socket.IO подключение к:', API_URL);

// Создаем экземпляр Socket.IO с настройками для VPS
const socket = io(API_URL, {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  path: '/socket.io', // Явно указываем путь
  transports: ['polling', 'websocket'], // Сначала polling, затем websocket
  query: {
    token: store.getters.authToken
  }
});

// Базовые обработчики событий
socket.on('connect', () => {
  console.log('Подключено к WebSocket, ID:', socket.id);
});

socket.on('connect_error', (error) => {
  console.error('Ошибка подключения WebSocket:', error.message);
  console.log('Детали ошибки:', error);
  
  // Обновляем токен авторизации при ошибке подключения
  socket.io.opts.query = { token: store.getters.authToken };
});

socket.on('disconnect', () => {
  console.log('Отключено от WebSocket');
});

socket.on('error', (error) => {
  console.error('Ошибка WebSocket:', error.message);
});

// Обработчик для получения списка чатов
socket.on('chats_list', (chats) => {
  if (Array.isArray(chats)) {
    console.log(`Получен список чатов через WebSocket (${chats.length} чатов)`);
    store.commit('setChats', chats);
  } else {
    console.error('Socket: Получен некорректный формат списка чатов:', chats);
  }
});

// Обработчик для уведомления об изменении списка чатов
socket.on('chats_changed', () => {
  console.log('Получено уведомление об изменении списка чатов');
  requestChats();
});

// Обработчик для обновления отдельного чата
socket.on('chat_updated', (updatedChat) => {
  if (updatedChat && updatedChat._id) {
    console.log(`Socket: Получено обновление чата ${updatedChat._id}`);
    store.dispatch('updateChatSilently', updatedChat);
  } else {
    console.error('Socket: Получен некорректный объект чата:', updatedChat);
  }
});

// Обработчик для нового сообщения
socket.on('new_message', (message) => {
  if (!message || !message._id) {
    console.error('Socket: Получен некорректный объект сообщения:', message);
    return;
  }
  
  console.log(`Socket: Получено новое сообщение ${message._id} для чата ${message.chat}`);
  
  // Проверяем, открыт ли сейчас этот чат
  const currentChatId = store.state.currentChatId;
  
  // Если сообщение для текущего открытого чата, добавляем его в список сообщений
  if (currentChatId === message.chat) {
    // Проверяем, нет ли уже такого сообщения (чтобы избежать дубликатов)
    const existingMessage = store.state.messages.find(m => m._id === message._id);
    if (!existingMessage) {
      store.dispatch('addMessage', message);
    }
  }
  
  // В любом случае обновляем список чатов
  store.dispatch('fetchChats');
});

// Функция для запроса списка чатов
const requestChats = () => {
  if (socket.connected) {
    console.log('Запрос списка чатов через WebSocket');
    socket.emit('request_chats');
  } else {
    console.log('WebSocket не подключен, запрос списка чатов через REST API');
    store.dispatch('fetchChats');
  }
};

// Функция для подписки на обновления чата
const subscribeToChat = (chatId) => {
  if (socket.connected) {
    console.log(`Подписка на обновления чата ${chatId}`);
    socket.emit('subscribe_to_chat', chatId);
  }
};

// Функция для отписки от обновлений чата
const unsubscribeFromChat = (chatId) => {
  if (socket.connected) {
    console.log(`Отписка от обновлений чата ${chatId}`);
    socket.emit('unsubscribe_from_chat', chatId);
  }
};

// Функция для запроса статистики постбэков
const requestPostbackStats = (dateFilter) => {
  if (socket.connected) {
    console.log('Запрос статистики постбэков через WebSocket');
    socket.emit('request_postback_stats', dateFilter);
  }
};

// Функция для подключения к WebSocket
const connect = () => {
  console.log('Подключение к WebSocket...');
  
  // Обновляем токен авторизации перед подключением
  socket.io.opts.query = { token: store.getters.authToken };
  
  socket.connect();
};

// Функция для отключения от WebSocket
const disconnect = () => {
  console.log('Отключение от WebSocket...');
  socket.disconnect();
};

// Экспортируем сокет и функции
export default socket;
export { 
  connect, 
  disconnect, 
  requestChats, 
  subscribeToChat, 
  unsubscribeFromChat,
  requestPostbackStats
}; 